export const MAX_PDF_SIZE_MB = 50;
export const MAX_PDF_SIZE_BYTES = MAX_PDF_SIZE_MB * 1024 * 1024;

export const getPdfName = (item) =>
  item?.name || item?.pdf_name || item?.title || item?.file_name || "PDF";

export const getPdfUrl = (item) =>
  item?.pdf_file || item?.pdf || item?.file || item?.url || item?.path || "";

export const formatFileSize = (bytes) =>
  bytes >= 1024 * 1024
    ? `${(bytes / (1024 * 1024)).toFixed(1)} MB`
    : `${Math.round(bytes / 1024)} KB`;

export const isPdfFile = (file) =>
  file?.type === "application/pdf" ||
  file?.name?.toLowerCase().endsWith(".pdf");
